<p-confirmDialog></p-confirmDialog>
<p-toast></p-toast>
<div class="map-form-container flex flex-row justify-content-between flex-wrap">
  <div class="map-section col-6">

    <!--        <mfs-request-openlayers-map-for-add-->
    <!--          [height]="'100%'"-->
    <!--          [zoom]="13"-->
    <!--          [drawingMode]="true"-->
    <!--          [polygonJson]="formData?.polygonJson"-->
    <!--          [(geometry)]="formData.polygon"-->
    <!--          (geometryChange)="onGeometryChange($event)"-->
    <!--          [(polygonArea)]="fieldArea"-->
    <!--          [isCenterMarker]="false"-->
    <!--          [multiPolygonJsonColors]="existingFieldsPolygons"-->
    <!--          (polygonJsonChange)="onPolygonChange($event)"-->
    <!--          (mapMove)="onMapMove($event)"-->
    <!--          [isLoading]="isLoadingFields"-->
    <!--          [allowRightClickExit]="true"-->
    <!--          (validationError)="onValidationError($event)"-->
    <!--        ></mfs-request-openlayers-map-for-add>-->

    <mfs-old-map
      [height]="'100%'"
      [allowDrawUnderSibling]="false"
      [zoom]="18"
      [center]="mapCenter"
      [fitAllSibling]="false"
      [drawingMode]="true"
      [polygonJson]="formData?.polygonJson"
      [(geometry)]="formData.polygon"
      [(polygonArea)]="fieldArea"
      [isCenterMarker]="false"
      (mapMove)="onMapMove($event)"
      (geometryChange)="onGeometryChange($event)"
      [isLoading]="isLoadingFields"
      [siblingPolygons]="existingFieldsPolygons"
      (validationError)="onValidationError($event)"

    ></mfs-old-map>


    @if (validationError) {
      <div class="validation-error mt-2 p-2"
           style="background-color: #fee; color: #c33; border: 1px solid #c33; border-radius: 4px;">
        <i class="pi pi-exclamation-triangle mr-2"></i>
        {{ validationError }}
      </div>
    }
  </div>
  <div class="form-section col-6 flex flex-column">
    <!-- Region selector (tree) -->
    <div class="form-field">
      <label class="form-label">{{ 'Region' | translate }} <span class="required">*</span></label>
      <msf-tree-select
        [(model)]="formData.regionId"
        [service]="regionManagerService"
        serviceMethod="getRegionsObservable"
        [placeholder]="'Select Region' | translate"
        [showClear]="true"
        [treeBy]="'parentId'"
      />
    </div>

    <div class="coordinates-row">
      <div class="form-field coordinates-field">
        <label class="form-label">{{ 'Latitude' | translate }}</label>
        <msf-input
          [(model)]="latitude"
          (modelChange)="decimalSeparatorMismatch = null; onCoordinatesChange()"
          (onDecimalSeparatorUsed)="onDecimalSeparatorUsed($event)"
          (onSeparatorMismatch)="decimalSeparatorMismatch = $event"
          [decimalSeparator]="preferredDecimalSeparator"
          type="number"
          [placeholder]="'lat' | translate"
          step="any"
          [maxFractionDigits]="10"
        />
      </div>

      <div class="form-field coordinates-field">
        <label class="form-label">{{ 'Longitude' | translate }}</label>
        <msf-input
          [(model)]="longitude"
          (modelChange)="decimalSeparatorMismatch = null; onCoordinatesChange()"
          (onDecimalSeparatorUsed)="onDecimalSeparatorUsed($event)"
          (onSeparatorMismatch)="decimalSeparatorMismatch = $event"
          [decimalSeparator]="preferredDecimalSeparator"
          type="number"
          [placeholder]="'lng' | translate"
          step="any"
          [maxFractionDigits]="10"
        />
      </div>
    </div>
    @if (decimalSeparatorMismatch) {
      <div class="validation-error coordinates-error">
        {{ getDecimalSeparatorMismatchMessage() }}
      </div>
    }

    <msf-form-builder
      flexDirection="row"
      [fields]="getFormConfig()"
      [(model)]="formData"
    ></msf-form-builder>

    <div class="flex flex-row justify-content-end align-items-end mt-3 gap-2">
      <p-button
        [severity]="'secondary'"
        [label]="'Cancel' | translate"
        class="p-button-text button-secondary"
        (click)="cancel()"
      ></p-button>
      <button
        pButton
        type="button"
        [label]="'Save' | translate"
        class="p-button-primary"
        [loading]="isSaving"
        [disabled]="isSaving || !!validationError || !formData.name || !(formData.polygonJson || formData.polygon)"
        (click)="save()"
      ></button>


    </div>
  </div>
</div>
